import ApiClient from '../ApiClient';

class CrmAiCallsAPI extends ApiClient {
    constructor() {
        super('crm/ai_calls', { accountScoped: true });
    }

    callback(id, data) {
        return axios.post(`${this.url}/${id}/callback`, data);
    }

    dispatch(id) {
        return axios.post(`${this.url}/${id}/trigger`);
    }

    getSettings() {
        return axios.get(`${this.url.replace('/ai_calls', '')}/ai_calls_settings`);
    }

    updateSettings(data) {
        return axios.put(`${this.url.replace('/ai_calls', '')}/ai_calls_settings`, data);
    }
}
export default new CrmAiCallsAPI();
